import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

import GetLinkableLocation from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/models/get-linkable-location';
import { OrganisationFormName } from '../../../../../../domain/enums/organisation-form-name';
import OrganisationUnit from '../../../../../../domain/models/organisation-unit';
import { useLazyGetLinkableLocationsQuery } from '../../components/link-room-modal/domain/queries/location-queries';
import OrganisationRoom from '../../domain/organisation-room';
import OrganisationRoomLink from '../../domain/organisation-room-link';

export type Props = {
  selectedOrganisationUnit: OrganisationUnit | undefined;
  form: UseFormReturn;
  isLoading: boolean;
};

export type ElectronicClientRecordHook = {
  watchedSelectedRoom: OrganisationRoomLink | undefined;
  selectedTableRoom: OrganisationRoom | undefined;
  locationsData: GetLinkableLocation[] | undefined;
  locationsError: Error | null;
  locationsIsLoading: boolean;
  form: UseFormReturn;
  isLoading: boolean;
  setSelectedTableRoom: Dispatch<SetStateAction<OrganisationRoom | undefined>>;
  loadLocations: () => void;
};

const useElectronicClientRecordHook = ({ selectedOrganisationUnit, form, isLoading }: Props): ElectronicClientRecordHook => {
  const [selectedTableRoom, setSelectedTableRoom] = useState<OrganisationRoom | undefined>();

  const {
    refetch: refetchLocations,
    data: locationsData,
    error: locationsError,
    isLoading: locationsIsLoading,
  } = useLazyGetLinkableLocationsQuery({ organisationUnitId: selectedOrganisationUnit?.id ?? '' });
  const watchedSelectedRoom: OrganisationRoomLink | undefined = form.watch(OrganisationFormName.ElectronicClientRecordRoom);

  useEffect(() => {
    if (selectedOrganisationUnit?.electronicClientRecordLocation) {
      form.setValue(OrganisationFormName.ElectronicClientRecordRoom, {
        name: selectedOrganisationUnit?.electronicClientRecordLocation?.name,
        connectorId: selectedOrganisationUnit?.electronicClientRecordLocation?.connectorId,
        electronicClientRecordLocationId: selectedOrganisationUnit?.electronicClientRecordLocation?.electronicClientRecordLocationId,
        id: selectedOrganisationUnit?.electronicClientRecordLocation?.id,
        result: selectedOrganisationUnit?.electronicClientRecordLocation?.result,
      });
    } else {
      form.setValue(OrganisationFormName.ElectronicClientRecordRoom, {});
    }
  }, [selectedOrganisationUnit]);

  const loadLocations = (): void => {
    refetchLocations();
  };

  return {
    watchedSelectedRoom,
    selectedTableRoom,
    locationsData,
    locationsError,
    locationsIsLoading,
    form,
    isLoading,
    setSelectedTableRoom,
    loadLocations,
  };
};

export default useElectronicClientRecordHook;
